import type { ExpectedType } from './ExpectedType'
import { expectedTypeKey } from './expectedTypeKey'

export const isExpectedType = (value: string): value is ExpectedType =>
  Object.hasOwn(expectedTypeKey, value)
